import React from "react";
import Box from "@mui/material/Box";
import { Navigate } from "react-router-dom";
import { PowerBIEmbed } from "powerbi-client-react";
import { TokenType } from "powerbi-models";
import { IReportViewProps } from "../types/interfaces/IReportViewProps";
import { useErrorContext } from "../../global/hooks/useErrorContext";
import "../styles/ReportView.css";

//This component is responsible for displaying a report.
export const ReportView: React.FC<IReportViewProps> = ({ reportData }) => {
    const { setError } = useErrorContext();

    if (!reportData || !reportData.ReportId || !reportData.EmbedUrl || !reportData.EmbedToken) {
        setError({ message: "Unable to display report: missing embed data.", statusCode: 400 });
        return <Navigate to="/error" />;
    }

    const tokenTypeString = reportData.TokenType?.split('.').pop();
    const tokenType =
        tokenTypeString === "Aad" ? TokenType.Aad :
        tokenTypeString === "Embed" ? TokenType.Embed :
        undefined;

    return (
        <Box className="report-view-container" sx={{ ml: 10, mb: 1, position: 'relative', overflow: 'auto' }}>
            <PowerBIEmbed
                embedConfig={{
                    type: reportData.Type ?? undefined,
                    id: reportData.ReportId,
                    embedUrl: reportData.EmbedUrl,
                    accessToken: reportData.EmbedToken,
                    tokenType,
                    settings: {
                        panes: {
                            filters: { visible: false },
                            pageNavigation: { visible: true }
                        }
                    }
                }}
                cssClassName="powerbi-embed"
            />
        </Box>
    );
};
